import { ZIP_CODE_REGEX_BY_COUNTRY } from '../../constants/country';
import { Country } from '../../types/country';
import { getCurrentCountry } from '../../utils/country';

type ZipCodeConfig = {
  regex: RegExp;
  webConfig: {
    mask: undefined | RegExp[];
    mode: 'numeric' | undefined;
    type: 'tel' | 'text';
  };
  mobileConfig: {
    mask: undefined | string;
    keyboardType: 'numeric' | 'default';
    type: 'tel' | 'text';
  };
};

export const ZIP_CODE_VALIDATION_BY_COUNTRY: Record<Country, ZipCodeConfig> = {
  FR: {
    regex: ZIP_CODE_REGEX_BY_COUNTRY.FR,
    webConfig: {
      mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
      mode: 'numeric',
      type: 'tel',
    },
    mobileConfig: {
      mask: '99999',
      keyboardType: 'numeric',
      type: 'tel',
    },
  },
  GB: {
    regex: ZIP_CODE_REGEX_BY_COUNTRY.GB,
    webConfig: {
      mask: undefined,
      mode: undefined,
      type: 'text',
    },
    mobileConfig: {
      mask: undefined,
      keyboardType: 'default',
      type: 'text',
    },
  },
  // TODO I18N: Check config for DACH countries
  DE: {
    regex: ZIP_CODE_REGEX_BY_COUNTRY.DE,
    webConfig: {
      mask: undefined,
      mode: undefined,
      type: 'text',
    },
    mobileConfig: {
      mask: undefined,
      keyboardType: 'default',
      type: 'text',
    },
  },
  AT: {
    regex: ZIP_CODE_REGEX_BY_COUNTRY.AT,
    webConfig: {
      mask: undefined,
      mode: undefined,
      type: 'text',
    },
    mobileConfig: {
      mask: undefined,
      keyboardType: 'default',
      type: 'text',
    },
  },
  CH: {
    regex: ZIP_CODE_REGEX_BY_COUNTRY.CH,
    webConfig: {
      mask: undefined,
      mode: undefined,
      type: 'text',
    },
    mobileConfig: {
      mask: undefined,
      keyboardType: 'default',
      type: 'text',
    },
  },
};

const getLocaleZipCodeValidation = () => ZIP_CODE_VALIDATION_BY_COUNTRY[getCurrentCountry()];

export const getZipCodeWebConfig = () => getLocaleZipCodeValidation().webConfig;
export const getZipCodeMobileConfig = () => getLocaleZipCodeValidation().mobileConfig;

export const validateZipCode = (value?: string) => (value ? getLocaleZipCodeValidation().regex.test(value) : false);
